(() => {
  const contentPageParam = '?ref=videos';
  const openVTButton = document.querySelector('.js-vt-mobile-app');
  const overlayViewClass = document.querySelector(
    '.js-content-page-use-case-selector'
  );
  const showContentClasses = document.querySelectorAll(
    '.js-content-videos-use-case'
  );
  const showContentlink = document.querySelector(
    '.js-content-page-videos-show'
  );
  const trackFeatureLinks = document.querySelectorAll(
    '.js-content-page-use-case-selector-track-link'
  );

  const appendContentPageParam = () => {
    const contentPageUrl = `${window.location.href}${contentPageParam}`;

    // eslint-disable-next-line no-undef
    Turbolinks.controller.pushHistoryWithLocationAndRestorationIdentifier(
      contentPageUrl,
      // eslint-disable-next-line no-undef
      Turbolinks.uuid()
    );
  };

  const showContent = appendParam => {
    overlayViewClass.classList.add('hidden');
    showContentClasses.forEach(showContentClass => {
      showContentClass.classList.remove('hidden');
      showContentClass.classList.add(
        'animate__animated',
        'animate__fadeIn',
        'animate__fast'
      );
    });

    if (appendParam && !window.Sofatutor.browser.isMobileApp)
      appendContentPageParam();
  };

  const checkContentPageParam = () => {
    if (window.location.href.indexOf(contentPageParam) > -1) showContent(false);
  };

  const trackButtons = elem => {
    const eventName = elem.dataset.event;
    const profileProperties = {
      profile_type: window.Sofatutor.profile.currentProfileType(),
      profile_level: window.Sofatutor.profileLevel,
      profile_id: window.Sofatutor.profile.currentProfileId()
    };
    const payload = {
      ...profileProperties,
      subject: elem.dataset.subject,
      subject_level: elem.dataset.subjectLevel
    };

    if (eventName === 'use_case_selector_video_clicked') {
      const videoClickedPayload = {
        ...profileProperties,
        content_page_id: elem.dataset.contentPageId,
        content_page_type: elem.dataset.contentPageType,
        referrer: 'useCaseSelector',
        subject: elem.dataset.subject,
        subject_level: elem.dataset.subjectLevel
      };

      window.Sofatutor.tracking.amplitude.track(eventName, payload);
      window.Sofatutor.tracking.amplitude.track(
        'content_page_visited',
        videoClickedPayload
      );
    } else {
      window.Sofatutor.tracking.amplitude.track(eventName, payload);
    }
  };

  const handleMobileApp = e => {
    e.preventDefault();
    const url = e.target.href || e.currentTarget.href;
    const appEvent = window.Sofatutor.MobileApp.createEvent(
      'openVocabularyTrainerApp',
      { url }
    );

    window.Sofatutor.MobileApp.sendEvent(appEvent);
  };

  showContentlink?.addEventListener('click', () => showContent(true));
  trackFeatureLinks?.forEach(link =>
    link.addEventListener('click', e => trackButtons(e.currentTarget))
  );

  if (window.Sofatutor.browser.isMobileApp)
    openVTButton?.addEventListener('click', handleMobileApp);
  else checkContentPageParam();
})();
